'use strict';

import ngResource from 'angular-resource';

class InstActivePowerService {
    constructor($resource) {
        'ngInject';
        this.api = $resource(
            '/api/inst_active_power/:id',
            { id: '@id' },
            {
                show  : { method: 'GET',  isArray: false },
                create: { method: 'POST', isArray: false },
                update: { method: 'PUT',  isArray: false }
            }
        );
    }
}

export default angular.module('leptonApp.InstActivePowerService', ['ngResource'])
    .service('InstActivePowerService', ['$resource', InstActivePowerService])
    .name;



// WEBPACK FOOTER //
// ./public/dev/components/api/inst_active_power/inst_active_power.service.js